<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">Register</h1>
              <p class="text-lead text-white">Get started by creating an account with us!</p>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <!-- Table -->
      <div class="row justify-content-center">
        <div class="col-lg-6 col-md-8">
          <div class="card bg-secondary border-0">
            <div class="card-body px-lg-5 py-lg-5">
              <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                <form role="form" @submit.prevent="handleSubmit(register_form)">
            

                  <base-input alternative
                              class="mb-3"
                              prepend-icon="ni ni-email-83"
                              placeholder="Email"
                              name="Email"
                              :rules="{required: true, email: true}"
                              v-model="model.email">
                  </base-input>

                  <base-input alternative
                              class="mb-3"
                              prepend-icon="ni ni-lock-circle-open"
                              placeholder="Password"
                              type="password"
                              name="Password"
                              :vid=model.password
                              :rules="{required: true, min: 6}"
                              v-model="model.password">
                  </base-input>
                  
                  
                   <base-input alternative
                              class="mb-3"
                              prepend-icon="ni ni-lock-circle-open"
                              placeholder="Confirm password"
                              type="password"
                              name="Confirm Password"
                              :rules="{required: true, confirmed:model.password}"
                              v-model="model.c_password">
                  </base-input>
       
           
                  <div class="text-center">
                    <button  class="btn btn-primary mt-4" native-type="submit">Create account</button>
                  </div>
                </form>
              </validation-observer>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'
  import {UserService} from '@/services/user.service'
  
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';
  
  export default {
    name: 'register',
    data() {
      return {
        model: {
          name: '',
          email: '',
          password: '',
          confirm_password:'',
          agree: false
        }
      }
    },
    methods: {
      
      async register_form() {
      	 swal.showLoading();
      	const vm = this;
        let uri = this.$base_url+'/api/v1/register_client';
       	ApiService.post(uri, this.model).then(response => {
         		if(response.data.success == 0){
         				swal.fire({
							title: `Oops`,
							text: response.data.error,
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-warning',
							icon: 'warning'
						  })
         		}
         		else{
         			 UserService.login(vm.model.email, vm.model.password)
                		.then(function(response){
                			swal.close();
                			//vm.$router.push('/onboarding');
                			vm.$router.push( '/onboarding-incorp-form');
                	});
         			
         		}
 
      		})
        
      }//end register_form
    }

  };
</script>
<style></style>











